import { Routes, Route } from 'react-router-dom';
import { Suspense, lazy, useEffect } from 'react';
import Alert from './components/Alert/AlertDialog';
import LinearProgressComponent from './components/LinearProgressComponent';
import Login from './pages/Login';
import ProtectedRoute from './components/protected-route/ProtectedRoute';

const PrivateLayout = lazy(() => import('./components/layout/PrivateLayout'));

const App = () => {
    const theme = localStorage.getItem('theme');

    useEffect(() => {
        if (theme === 'dark') {
            document.documentElement.setAttribute('data-theme', 'dark');
        } else {
            document.documentElement.setAttribute('data-theme', 'light');
        }
    }, [theme]);

    return (
        <Suspense fallback={<LinearProgressComponent />}>
            <Routes>
                <Route path="login" element={<Login />} />
                <Route path="login/:id" element={<Login />} />
                <Route
                    path="/*"
                    element={
                        <ProtectedRoute rol="viewer">
                            <PrivateLayout />
                        </ProtectedRoute>
                    }
                />
                <Route path="*" element={<p>There's nothing here: 404!</p>} />{' '}
                {/* <Route path="*" element={<Navigate replace to="/" />} /> */}
            </Routes>
            <Alert />
        </Suspense>
    );
};

export default App;
